import { myWalletTransactionColumns } from '../../../../config/wallet';
import WalletTransactionPage from './WalletTransactionPage';

const MyWalletTransactionPage = () => {
  return <WalletTransactionPage endpoint='transactions' columns={myWalletTransactionColumns} />;
};

export default MyWalletTransactionPage;
